/**
 * Typed error for token-refresh failures.
 *
 * `isTerminal` is the single source of truth for "is this failure fatal to the
 * session?". When `true`, the refresh token is genuinely dead (expired/revoked,
 * or Cognito returned an auth error) and the caller should log out. When
 * `false`, the failure is transient (network blip, throttling, 5xx, timeout)
 * and the caller should keep the session and let the request fail/retry.
 *
 * Fail-safe default: unknown failures are treated as transient (keep the user
 * logged in). A genuinely dead session surfaces a terminal error on the next
 * real refresh and logs out then.
 */
export default class RefreshError extends Error {
  constructor(message, { terminal = false } = {}) {
    super(message);
    this.name = 'RefreshError';
    this.isTerminal = terminal;
  }
}

export function terminalRefreshError(message) {
  return new RefreshError(message, { terminal: true });
}

export function transientRefreshError(message) {
  return new RefreshError(message, { terminal: false });
}
